module.exports = `:root {
  --primitiveColorNeutralBase920: #e6e7e8;
  --primitiveColorNeutralDarker820: #cccccc;
  --primitiveColorNeutralDark860: #d6d8d9;
  --primitiveColorNeutralLight940: #eeeeee;
  --primitiveColorNeutralLighter980: #f8f8f8;
  --primitiveColorPrimaryBase490: #00837c;
  --primitiveColorPrimaryDarker230: #013f3c;
  --primitiveColorPrimaryDark370: #00625d;
  --primitiveColorPrimaryLight570: #009990;
  --primitiveColorPrimaryLighter640: #00afa5;
  --primitiveColorSecondaryBase260: #063f7b;
  --primitiveColorSecondaryDarker150: #04274d;
  --primitiveColorSecondaryDark220: #05376b;
  --primitiveColorSecondaryLight910: #dae8f7;
  --primitiveColorSecondaryLighter970: #f3f7fc;
  --primitiveColorDarkBase170: #022b4f;
  --primitiveColorDarkDarker0: #000000;
  --primitiveColorDarkDark90: #021c33;
  --primitiveColorDarkLight440: #376d95;
  --primitiveColorDarkLighter680: #6dafdb;
  --primitiveColorLightBase1000: #ffffff;
  --primitiveColorLightDarker930: #ececec;
  --primitiveColorLightDark980: #f9f9f9;
  --primitiveColorCorrectBase590: #11a53c;
  --primitiveColorCorrectDarker340: #095d21;
  --primitiveColorCorrectDark420: #0c732a;
  --primitiveColorCorrectLight880: #bae9c7;
  --primitiveColorCorrectLighter950: #e0f5e6;
  --primitiveColorErrorBase430: #c31818;
  --primitiveColorErrorDarker330: #991212;
  --primitiveColorErrorDark380: #b01616;
  --primitiveColorErrorLight810: #ecbdbf;
  --primitiveColorErrorLighter960: #fff1f1;
  --primitiveColorTextBase140: #242424;
  --primitiveColorTextDarker0: #000000;
  --primitiveColorTextDark50: #121212;
  --primitiveColorTextLight500: #777777;
  --primitiveColorTextLighter620: #979797;
  --primitiveColorHighlightBase900: #ffe233;
  --primitiveColorHighlightDarker740: #e8a804;
  --primitiveColorHighlightDark860: #fad305;
  --primitiveColorHighlightLight950: #fff2a3;
  --primitiveColorHighlightLighter970: #fff8cc;
  --primitiveColorBorderBase710: #aeaeb1;
  --primitiveColorBorderDarker570: #89898c;
  --primitiveColorBorderDark620: #969699;
  --primitiveColorBorderLight730: #b3b3b3;
  --primitiveColorBorderLighter910: #c8c8cc;
  --primitiveColorDisabledBase620: #979797;
  --primitiveColorDisabledDarker380: #595959;
  --primitiveColorDisabledDark530: #808080;
  --primitiveColorDisabledLight730: #b3b3b3;
  --primitiveColorDisabledLighter870: #dadada;
  --primitiveColorLinkBase480: #0a70e9;
  --primitiveColorLinkDarker280: #053e94;
  --primitiveColorLinkDark360: #0651bf;
  --primitiveColorLinkLight540: #2980ff;
  --primitiveColorLinkLighter630: #599cff;
  --primitiveColorWarningBase487: #c25100;
  --primitiveColorWarningDarker278: #702e00;
  --primitiveColorWarningDark422: #a54800;
  --primitiveColorWarningLight950: #fff1b8;
  --primitiveColorWarningLighter984: #fffbe6;
  --primitiveTypographyTypescale1: 3rem;
  --primitiveTypographyTypescale2: 2.25rem;
  --primitiveTypographyTypescale3: 2rem;
  --primitiveTypographyTypescale4: 1.75rem;
  --primitiveTypographyTypescale5: 1.5rem;
  --primitiveTypographyTypescale6: 1.25rem;
  --primitiveTypographyTypescale7: 1.125rem;
  --primitiveTypographyTypescale8: 1rem;
  --primitiveTypographyFontWeightRegular: 450;
  --primitiveTypographyFontWeightMedium: 500;
  --primitiveTypographyFontWeightBold: 700;
  --primitiveTypographyLetterSpacingBold: -0.0125em;
  --primitiveTypographyLetterSpacingMedium: -0.015em;
  --primitiveTypographyLetterSpacingRegular: 0.03em;
}
`;